import {Injectable} from '@angular/core';
import {AppSettings} from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import {AutenticacionService} from './autenticacion.service';
import {map} from 'rxjs/operators';
import {TipoOpcion} from '../_enums/enum';
import {forkJoin, Observable} from 'rxjs';
import {DivisionPoliticaService} from './division-politica.service';
import {CanalService} from './canal.service';
import {SarlaftCondicionesCanales} from '../_models/sarlaft-condiciones-canales';
import {ActividadEconomicaService} from './actividad-economica.service';
import {ListaService} from './lista.service';
import {Variable} from '../_models/variable-sarlaft';
import {ProductoService} from "./producto.service";
import {OcupacionesService} from "./ocupaciones.service";

@Injectable({
  providedIn: 'root'
})
export class SarlaftCondicionesService {

  private rutServicio = AppSettings.rutServiciosSarlaft + '/api/riesgosSarlaftVariablesCondicionesDivisionesPoliticas';
  private rutServicioCanal = AppSettings.rutServiciosSarlaft + '/api/riesgosSarlaftVariablesCondicionesCanales';
  private rutAdjunto = AppSettings.rutServiciosSarlaft + '/api/riesgosSarlaftVariablesAdjuntosCargue';
  private rutActividadesEconomicas = AppSettings.rutServiciosSarlaft + '/api/riesgosSarlaftVariablesCondicionesActividadesEconomicas';
  private rutaVariables = AppSettings.rutServiciosSarlaft + '/api/riesgosSarlaftVariablesCondicionesInformacionFinanciera/';
  private rutaPep = AppSettings.rutServiciosSarlaft + '/api/riesgosSarlaftVariablesCondicionesPep';
  private rutaTipoOcupaciones = AppSettings.rutServiciosSarlaft + '/api/riesgosSarlaftVariablesCondicionesTiposOcupaciones';
  private rutaProducto = AppSettings.rutServiciosSarlaft + '/api/riesgosSarlaftVariablesCondicionesProductos';
  private rutaOcupa = AppSettings.rutServiciosSarlaft + '/api/riesgosSarlaftVariablesCondicionesOcupaciones'

  constructor( private httpClient: HttpClient,
               private autServicio: AutenticacionService,
               private divisionPoliticaService: DivisionPoliticaService,
               private canalesService: CanalService,
               private actividadEconomica: ActividadEconomicaService,
               private lisServicio: ListaService,
               private productoService: ProductoService,
               private ocupaService: OcupacionesService) {
  }

  ejecutarServicios(opcion: TipoOpcion, filtroVariable: Variable): Observable<any[]> {
    const observables = this.obtenerObservablesAEjecutar(opcion, filtroVariable);
    return forkJoin(observables);
  }

  private obtenerObservablesAEjecutar(opcion: TipoOpcion, filtroVariable: Variable): Observable<any>[] {
    switch (opcion) {
      case TipoOpcion.NACION:
        return [this.obtenerItemsNacionalidad(), this.divisionPoliticaService.obtenerPorTipo('1')];
      case TipoOpcion.JURISD:
        return [this.obtenerItemsJurisdiccion(), this.divisionPoliticaService.obtenerPorTipo('1')];
      case TipoOpcion.VCANAL:
        return [this.obtenerItemsCanal(), this.canalesService.listadoCanalesHabilitados() ];
      case TipoOpcion.ACTECO:
        return [this.obtenerItemsActividadEconomica(), this.actividadEconomica.listarPorTipo('4')];
      case TipoOpcion.INFIIN:
      case TipoOpcion.INFIEG:
      case TipoOpcion.INFIAC:
      case TipoOpcion.INFIPT:
      case TipoOpcion.INFIPA:
        return [this.obtenerInformacionVariables(filtroVariable)];
      case TipoOpcion.TIPOCU:
        return [ this.obtenerTipoOcupaciones(), this.lisServicio.getMasterDetails("ListasTiposOcupaciones")];
      case TipoOpcion.PEP:
        return [this.obtenerItemsPep(), this.lisServicio.getMasterDetails( 'ListasPep' )];
      case TipoOpcion.PRODUC:
        return [this.obtenerItemsProducto(), this.productoService.listadoHabilitados()];
      case TipoOpcion.OCUPAC:
        return [this.obtenerItemsOcupa(), this.ocupaService.listByNivel(4)];
      default:
        return [];
    }
  }

  obtenerCargueAdjunto(idRiesgoSarlaftVariable: string) {
    return this.httpClient.get( this.rutAdjunto + '/unique/' + idRiesgoSarlaftVariable).pipe( map( res => res as any ) );
  }
  guardarRegistrosAdjunto(objeto: any, idRiesgoSarlaftVariable: string) {
    return this.httpClient.post( this.rutAdjunto + '/guardarRegistros/riesgoSarlaftVariable/' + idRiesgoSarlaftVariable, objeto).pipe( map( res => res as any ) );
  }

  obtenerItemsNacionalidad(): Observable<any[]> {
    return this.httpClient.get(this.rutServicio).pipe(
      map((res: any[]) => res.filter(item =>
        item.codigoDivisionPoliticaPadre === null && item.descripcionDivisionPoliticaPadre === null
      ))
    );
  }

  obtenerItemsCanal(): Observable<any[]> {
    return this.httpClient.get(this.rutServicioCanal).pipe(
      map((res: any[]) => res.filter(item =>
        item.codigoCanal !== null && item.canal !== null
      ))
    );
  }

  obtenerRuta(tipo: string) {
    let ruta = '';
    switch (tipo) {
      case TipoOpcion.VCANAL:
        return ruta = this.rutServicioCanal;
      case TipoOpcion.NACION:
      case TipoOpcion.JURISD:
        return ruta = this.rutServicio;
      case TipoOpcion.PEP:
        return ruta = this.rutaPep;
      case TipoOpcion.ACTECO:
        return ruta = this.rutActividadesEconomicas;
      case TipoOpcion.TIPOCU:
        return ruta = this.rutaTipoOcupaciones;
      case TipoOpcion.PRODUC:
        return ruta = this.rutaProducto;
      case TipoOpcion.OCUPAC:
        return ruta = this.rutaOcupa;
    }
  }

  crearCondicion(objetoCondicionVariable: any, tipo: string) {
    let ruta = this.obtenerRuta(tipo);
    objetoCondicionVariable.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post(ruta, objetoCondicionVariable).pipe(map(res => res as any));
  }

  actualizarCondicion(objetoCondicionVariable: any, tipo: string) {
    let ruta = this.obtenerRuta(tipo);
    objetoCondicionVariable.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.put(ruta, objetoCondicionVariable).pipe(map(res => res as any));
  }

  obtenerItemsJurisdiccion(): Observable<any[]> {
    return this.httpClient.get(this.rutServicio).pipe(
      map((res: any[]) => res.filter(item => item.codigoDivisionPoliticaPadre !== null )));
  }

  obtenerItemsActividadEconomica(): Observable<any[]> {
    return this.httpClient.get( `${this.rutActividadesEconomicas}/enabled`).pipe(
      map((res: any[]) => res as any));
  }

  obtenerItemsPep(): Observable<any[]> {
    return this.httpClient.get(this.rutaPep).pipe(
      map((res: any[]) => res as any));
  }

  obtenerItemsProducto(): Observable<any[]> {
    return this.httpClient.get(this.rutaProducto).pipe(
      map((res: any[]) => res as any));
  }

  obtenerItemsOcupa(): Observable<any[]> {
    return this.httpClient.get(this.rutaOcupa).pipe(
      map((res: any[]) => res as any));
  }

  obtenerTipoOcupaciones(): Observable<any[]> {
    return this.httpClient.get(this.rutaTipoOcupaciones + '/enabled').pipe(
      map((res: any[]) => res as any));
  }

  obtenerInformacionVariables(filtroVariable: Variable): Observable<any[]> {
    return this.httpClient.get(`${this.rutaVariables}riesgosSarlaftVariables/${filtroVariable.idRiesgoSarlaftVariable}/enabled`).pipe(
      map((res: any[]) => res as any));
  }

  validarCondicionFinanciera(objetoCondicionVariable: any) {
    objetoCondicionVariable.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httpClient.post(`${this.rutaVariables}validarRangos`, objetoCondicionVariable).pipe(map(res => res as any));
  }

  bulkCondicionFinanciera(listaCondicionVariable: any) {
    listaCondicionVariable.forEach(x => {
      x.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    });
    return this.httpClient.post(`${this.rutaVariables}bulk`, listaCondicionVariable).pipe(map(res => res as any));
  }

}
